@if (error$ && (error$ | async) && ((error$ | async)! | isFailure) && !((error$ | async)! |
isFormFailure)) {
<aix-notification status="error" [canClose]="canClose()" [isOpen]="true" [classList]="['u-mb8']">
    <span class="ph-mask" [innerHTML]="(errorText$ | async)! | aixSanitize"></span>
    @if (enableDebugging) {
    <div class="error-box__dev-message">{{ debugText$ | async }}</div>
    }
</aix-notification>
}
